class abTestService {
    setAbTest(obj: Record<string, any>) {
        localStorage.setItem("ab-test", JSON.stringify(obj))
    }
    
    setInstallmentUser() {
        const rValue = Math.random()

        let abTest = localStorage.getItem("ab-test") ? JSON.parse(localStorage.getItem("ab-test")) : {}

        localStorage.setItem("ab-test", JSON.stringify({
            ...abTest, percent: rValue
        }))
    }

    removeInstallmentUser() {
        if (typeof window !== "undefined") {
            const abTest = localStorage.getItem("ab-test") ? JSON.parse(localStorage.getItem("ab-test")) : {}

            delete abTest.percent

            localStorage.setItem("ab-test", JSON.stringify(abTest))
        }
    }

    getAbTest() {
        if (typeof window !== "undefined") {
            const abTest = localStorage.getItem("ab-test") ? JSON.parse(localStorage.getItem("ab-test")) : {}

            return abTest
        } return {}
    }

    getInstallmentUser() {
        return this.getAbTest()?.percent
    }

    includesInstallmentUser(): boolean {
        const percent = this.getInstallmentUser()
        return Boolean(percent <= 1)
    }

    setLookingForInstallments(): void {
        const abTest = this.getAbTest()

        const newAbTest = {
            ...abTest,
            looksForInstallments: true
        }

        this.setAbTest(newAbTest)
    }

    isLookingForInstallments(): boolean {
        const abTest = this.getAbTest()
        return abTest.looksForInstallments ?? false
    }
}
export default new abTestService();